const Image = ({fieldValue}) => {
  return <img style={{marginTop: '30px', height: '90px', width: '200px', background: 'white', borderRadius: '10px'}} src={fieldValue} />
}

export default Image;
